import { PencilIcon } from '@heroicons/react/20/solid'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const getPlacowkaId = value => {
	if (!value) return null
	if (typeof value === 'object') return value._id || value.id || null
	return `${value}`.trim() || null
}

const renderPlacowkaName = (training, plainClassName = '') => {
	const placowkaId = getPlacowkaId(training?.placowkaId)
	const placowkaName = training?.placowkaName || '—'

	if (placowkaId && training?.placowkaName) {
		return (
			<Link
				to={`/klienci/placowki/details/${placowkaId}`}
				className="text-blue-600 hover:text-blue-800 hover:underline"
			>
				{placowkaName}
			</Link>
		)
	}

	return <span className={plainClassName}>{placowkaName}</span>
}

export default function TrainingDetailsCard({ training, statusLabel, createdDate }) {
	const { t } = useTranslation()

	return (
		<div className="mb-5 rounded-md border border-gray-200 bg-white px-5 py-4 shadow-sm">
			<div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
				<div>
					<h1 className="text-lg font-semibold text-gray-900">{training?.nazwa || '—'}</h1>
					<p className="mt-1 text-sm">{renderPlacowkaName(training, 'text-gray-600')}</p>
					<p className="mt-1 text-sm text-gray-500">{training?.placowkaAddress || '—'}</p>
				</div>
				<div className="flex flex-wrap items-center gap-2">
					<Link
						to={`/centrumSzkolen/szkolenia/edit/${training?._id}`}
						className="inline-flex items-center gap-1 rounded-md border border-blue-100 bg-blue-50 px-3 py-1.5 text-sm font-medium text-blue-700 hover:bg-blue-100"
					>
						<PencilIcon className="h-4 w-4" />
						<span>{t('trainings.list.table.edit')}</span>
					</Link>
				</div>
			</div>

			<dl className="mt-4 grid grid-cols-1 gap-3 border-t border-gray-100 pt-4 text-sm sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
				<div>
					<dt className="text-xs font-medium uppercase tracking-wide text-gray-500">{t('trainings.add.placowkaLabel')}</dt>
					<dd className="mt-0.5">{renderPlacowkaName(training, 'text-gray-900')}</dd>
				</div>
				<div>
					<dt className="text-xs font-medium uppercase tracking-wide text-gray-500">{t('trainings.list.table.voivodeship')}</dt>
					<dd className="mt-0.5 text-gray-900">{training?.placowkaWojewodztwo || '—'}</dd>
				</div>
				<div>
					<dt className="text-xs font-medium uppercase tracking-wide text-gray-500">{t('placowkaPicker.table.city')}</dt>
					<dd className="mt-0.5 text-gray-900">{training?.placowkaMiasto || '—'}</dd>
				</div>
				<div>
					<dt className="text-xs font-medium uppercase tracking-wide text-gray-500">{t('placowkaPicker.table.gmina')}</dt>
					<dd className="mt-0.5 text-gray-900">{training?.placowkaGmina || '—'}</dd>
				</div>
				<div>
					<dt className="text-xs font-medium uppercase tracking-wide text-gray-500">{t('placowkaPicker.table.powiat')}</dt>
					<dd className="mt-0.5 text-gray-900">{training?.placowkaPowiat || '—'}</dd>
				</div>
				<div>
					<dt className="text-xs font-medium uppercase tracking-wide text-gray-500">{t('placowkaPicker.table.type')}</dt>
					<dd className="mt-0.5 text-gray-900">{training?.placowkaTyp || '—'}</dd>
				</div>
				<div>
					<dt className="text-xs font-medium uppercase tracking-wide text-gray-500">{t('trainings.form.fields.status')}</dt>
					<dd className="mt-0.5 text-gray-900">{statusLabel || '—'}</dd>
				</div>
				<div>
					<dt className="text-xs font-medium uppercase tracking-wide text-gray-500">{t('trainings.details.fields.created')}</dt>
					<dd className="mt-0.5 text-gray-900">{createdDate || '—'}</dd>
				</div>
			</dl>
		</div>
	)
}
